var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"router-content"},[_c('keep-alive',{attrs:{"include":['home', 'focusNews', 'videoPage', 'special']}},[_c('router-view')],1)],1),_c('Bottom',{staticStyle:{"height":"330px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }